import { Field } from 'react-final-form';

import { Icon } from '@change-corgi/design-system-legacy/components/icon';
import { iconClose } from '@change-corgi/design-system-legacy/icons';
import { Box } from '@change-corgi/design-system-legacy/layout';
import { buttonResetStyles } from '@change-corgi/design-system-legacy/reset';
import { derivedStyle } from '@change-corgi/design-system-legacy/theme';

import { EmbeddedMedia } from 'src/app/shared/components/embeddedMedia';

import type { PetitionUpdateFormValues } from '../../../../types';

import type { EmbeddedMediaPreviewFetchErrorType } from './hooks/useEmbeddedMediaPreview';
import { useEmbeddedMediaPreview } from './hooks/useEmbeddedMediaPreview';

export type EmbeddedMediaPreviewProps = {
	value: string;
	onFetchSuccess?: () => void;
	onFetchError?: (errorType: EmbeddedMediaPreviewFetchErrorType) => void;
	onClosePreview?: () => void;
};

export function EmbeddedMediaPreview(props: EmbeddedMediaPreviewProps) {
	const {
		data: { ariaLabel, media },
		actions: { handleClosePreviewClick },
	} = useEmbeddedMediaPreview(props);
	return (
		<>
			{media && (
				<Box pt={[16, 24]} sx={{ position: 'relative' }}>
					<button
						type="button"
						sx={{
							...buttonResetStyles,
							cursor: 'pointer',
							border: derivedStyle(({ colors }) => `2px solid ${colors['primary-changeRed']}`),
							width: 42,
							height: 42,
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							background: 'primary-white',
							borderRadius: 'standard',
							position: 'absolute',
							zIndex: 1,
							right: -10,
							top: 10,
						}}
						onClick={handleClosePreviewClick}
						aria-label={ariaLabel}
						data-testid="embedded-media-preview-close-button"
					>
						<Icon icon={iconClose} size="xl" color="primary-changeRed" />
					</button>
					<EmbeddedMedia html={media} />
				</Box>
			)}
			<Field<PetitionUpdateFormValues['embeddedMediaUrl']> name="embeddedMediaUrl" type="input">
				{({ input }) => <input {...input} type="hidden" name="embeddedMediaUrl" />}
			</Field>
		</>
	);
}
